





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "attendanceList",
        components: {},
        mixins:[]
    })
    export default class attendanceList extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
